import React, { Component } from 'react';
import DiscussionPointIcon from '../../assets/Discussion_Red';

import style from './discussionPoint.module.scss';

const DiscussionPoint = ({ body, detail_type, index }) => (
  <div className={style.discussionPoint}>
    <h4 className={style.discussionPointTitle}>
      Discussion Point
      <span className={style.dicussionPointIcon}>
        <DiscussionPointIcon />
      </span>
    </h4>
    <div dangerouslySetInnerHTML={{ __html: body }} />
  </div>
);

export default DiscussionPoint;



// WEBPACK FOOTER //
// ./src/components/tour/details/teasers/DiscussionPoint.js